import Backbone from 'backbone';
import Marionette from 'backbone.marionette';

var CellView = Marionette.ItemView.extend({
  template: require('../templates/cell.html'),
  tagName: 'td',
  templateHelpers(){
    return this.options;
  },

  ui: {
    description: '.description'
  },
  triggers: {
    'keyup @ui.description': 'update',
    'change @ui.description': 'update'
  },

  onUpdate(){
    this.model.set('description', this.ui.description.val());
  }
});

var RowView = Marionette.CompositeView.extend({
  template: require('../templates/choice.html'),
  tagName: 'tr',
  childView: CellView,

  ui: {
    delete : '.remove-choice',
    colour : '.choice-colour',
    name : '.choice-name'
  },
  triggers: {
    'click @ui.delete': 'remove',
    'keyup @ui.name' : 'update',
    'change @ui.name' : 'update',
    'change @ui.colour' : 'update'
  },

  onUpdate(){
    this.model.set('name', this.ui.name.val());
    this.model.set('colour', this.ui.colour.val());
  },

  initialize(){
    this.collection = this.model.get('cells');
  },

  childViewOptions(model, index) {
    return {
      key: index,
      row_key: this.options.key,
      week_key: this.options.week_key
    };
  },

  templateHelpers(){
    return this.options;
  }
});

var RowListView = Marionette.CollectionView.extend({
  childView: RowView,
  tagName: 'tbody',
  onShow(){
    // Horrid hack because Backbone wraps everything up and tables
    // do not like that :(
    this.$el = this.$el.parent();
    this.render();
  },
  onChildviewRemove(child){
    if(confirm('Are you sure you want to remove ' + child.model.get('name') + '?')){
      this.collection.remove(child.model);
      this.render();
    }
  },
  childViewOptions(model, index) {
    model.set('order', index);
    return {
      key: index,
      week_key: this.options.key
    };
  }
});

var HeaderView = Marionette.LayoutView.extend({
  template: require('../templates/col.html'),
  tagName: 'th',

  ui : {
    remove : '.remove-col',
    edit : '.edit'
  },
  triggers: {
    'click @ui.remove' : 'remove',
    'keyup @ui.edit' : 'update',
    'update @ui.edit' : 'update'
  },

  onUpdate(){
    this.model.set('description', this.ui.edit.val());
  },

  templateHelpers(){
    return this.options;
  }
});

var HeaderListView = Marionette.CompositeView.extend({
  template: require('../templates/header.html'),
  childView: HeaderView,
  tagName: 'tr',
  childViewContainer: 'th.c',

  ui: {
    new: 'th.new'
  },
  triggers: {
    'click @ui.new' : 'newCol'
  },

  onChildviewRemove(child){
    if(confirm('Are you sure you want to remove ' + child.model.get('description') + '?')){
      this.collection.remove(child.model);
      this.render();
      this.trigger('removeColumn', child.model);
    }
  },

  onNewCol(){
    this.trigger('addColumn');
  },

  childViewOptions(model, index) {
    model.set('order', index);
    return {
      key: index,
      week_key: this.options.key
    };
  },

  // Overriden so these go in the right place and we are able to add a + button
  // in the right place
  attachBuffer(compositeView) {
    var $container = this.getChildViewContainer(compositeView);
    $container.after(this._createBuffer(compositeView));
  },
  _insertAfter(childView) {
    var $container = this.getChildViewContainer(this, childView);
    $container.after(childView.el);
  }
});

var WeekView = Marionette.LayoutView.extend({
  template: require('../templates/week.html'),
  regions: {
    rows : 'tbody.content',
    header : 'thead'
  },

  ui: {
    new : '.new',
    remove : '.remove-week',
    weekNo: '.weekNo'
  },
  triggers: {
    'click @ui.remove' : 'remove',
    'click @ui.new' : 'newChoice',
    'update @ui.weekNo': 'update',
    'keyup @ui.weekNo': 'update'
  },

  onUpdate(){
    this.model.set('week', this.ui.weekNo.val());
  },

  onNewChoice(){
    var cells = new Backbone.Collection([]);
    this.model.get('columns').each(function (col){
      cells.push(new Backbone.Model({
        description: '',
        column_key: col.get('key')
      }));
    });

    this.collection.push(new Backbone.Model({
      colour: 'blue',
      cells
    }));
    this.doRender();
  },

  doRender(){
    this.headerView.render();
    this.rowsView.render();
  },

  initialize(){
    this.collection = this.model.get('content');
  },

  onShow(){
    this.rowsView = new RowListView({
      collection: this.collection,
      key: this.options.key
    });
    this.showChildView('rows', this.rowsView);

    this.headerView = new HeaderListView({
      collection: this.model.get('columns'),
      key: this.options.key
    });
    this.showChildView('header', this.headerView);

    this.model.set('key_up_to', this.model.get('columns').length);


    this.listenTo(this.headerView, 'removeColumn', function (col){
      this.collection.each(function (row){
        row.set('cells', new Backbone.Collection(row.get('cells').reject(function (cell){
          return cell.get('column_key') == col.get('key');
        })));
      });
      this.rowsView.render();
    });
    this.listenTo(this.headerView, 'addColumn', function (){
      this.model.set('key_up_to', this.model.get('key_up_to')+1);
      var col = new Backbone.Model({
        description: '',
        key: this.model.get('key_up_to')
      });
      this.model.get('columns').push(col);

      this.collection.each(function (row){
        row.get('cells').push({
          description: '',
          column_key: col.get('key')
        });
        row.set('cells', row.get('cells'));
      });

      this.rowsView.render();
      this.headerView.render();
    });
  }
});


var WeekListView = Marionette.CollectionView.extend({
  childView: WeekView,

  onChildviewRemove(child){
    if(confirm('Are you sure you want to remove week ' + child.model.get('week') + '?')){
      this.collection.remove(child.model);
      this.render();
    }
  },

  childViewOptions(model, index) {
    return {
      key: index
    };
  }
});

var MealPickerView = Marionette.LayoutView.extend({
  template: require('../templates/picker.html'),
  regions: {
    week : '.week-holder'
  },
  initialize(){
    this.collection = this.model.get('collection');
  },
  onShow(){
    this.weeksView = new WeekListView({
      collection: this.collection
    });
    this.showChildView('week', this.weeksView);
  },

  modelEvents: {
    saved: 'onModelSaved'
  },
  onModelSaved() {
    window.messages.add('The menu was saved. This may take up to 30 minutes to show up in Joinos', 'success');
  },

  ui: {
    new : '.week-add',
    description: '#description',
    name: '#name'
  },
  triggers: {
    'click @ui.new' : 'newWeek',
    'keyup @ui.description': 'update',
    'change @ui.description': 'update',
    'keyup @ui.name': 'update',
    'change @ui.name': 'update'
  },

  onUpdate(){
    this.model.set('name', this.ui.name.val());
    this.model.set('description', this.ui.description.val());
  },

  onNewWeek(){
    this.collection.push(new Backbone.Model({
      content: new Backbone.Collection([
        new Backbone.Model({
          colour: 'blue',
          cells: new Backbone.Collection([
            new Backbone.Model({ description: '', column_key: 0 })
          ])
        })
      ]),

      columns: new Backbone.Collection([
        new Backbone.Model({ description: '', key: 0 })
      ]),

      week: this.collection.length + 1
    }));
    this.weeksView.render();
  }
});

module.exports = MealPickerView;



// WEBPACK FOOTER //
// ./menupicker/views/mealpicker.js